<script setup>
import { shallowRef, onMounted } from 'vue'
import Smile1 from './icons/Smile1.vue'
import Smile2 from './icons/Smile2.vue'
import Smile3 from './icons/Smile3.vue'
import Smile4 from './icons/Smile4.vue'
import Smile5 from './icons/Smile5.vue'
import Smile6 from './icons/Smile6.vue'

const smiles = [Smile1, Smile2, Smile3, Smile4, Smile5, Smile6]
const smile = shallowRef(null)

onMounted(() => {
  smile.value = smiles[Math.floor(Math.random() * smiles.length)]
})
</script>

<template>
  <div class="web-loader wrapper">
    <component :is="smile" class="spinner" />
  </div>
</template>

<style lang="scss" scoped>
.web-loader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease-out;
  background-color: $color-1;

  inline-size: 100vw !important;

  .loading & {
    opacity: 1;
    visibility: visible;
    z-index: 100000000000;
  }
}

.spinner {
  max-inline-size: 30vw;
  max-block-size: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(0deg);

  color: $color-red;

  visibility: hidden;

  opacity: 0;

  animation: flickering 0.5s infinite;

  @keyframes flickering {
    0%,
    33% {
      color: $color-red;
    }
    34%,
    66% {
      color: $color-green;
    }
    67%,
    100% {
      color: $color-blue;
    }
  }

  .loading & {
    opacity: 1;
    visibility: visible;
  }
}
</style>
